<template>
  <div>
    <DxTagBox
      :id="'custom-templates' + dataField"
      :data-source="getDataSource"
      :max-displayed-tags="2"
      :show-multi-tag-only="false"
      :on-value-changed="onSelectionChanged"
      :items="items"
      :display-expr="displayExpr"
      :value-expr="valueExpr"
      :searchEnabled="true"
      :openOnFieldClick="true"
      searchMode="contains"
      :searchExpr="searchExpr"
      :itemTemplate="itemTemplate"
      :showClearButton="showClearButton"
      @initialized="initialized"
      ref="gc-tag-box"
      v-model="dataModel[dataField]"
      @focus-in="onFocusIn"
      @opened="onOpened"
      @enter-key="onPressEnterKey"
      :showSelectionControls="true"
      @content-ready="onContentReady"
      :wrapItemText="true"
      :dropDownOptions="{
        wrapperAttr: {
          class: 'gc-field-tag-dropDown',
        },
      }"
      :stylingMode="'outlined'"
      :selectAllMode="'allPages'"
    >
      <template #item-template="{ data }">
        <div class="custom-auto-complete">
          <span class="auto-complete-primary">{{ data[primaryText] }}</span>
          <br />
          <span class="auto-complete-secondary">{{ data[secondaryText] }}</span>
        </div>
      </template>

      <template #status-item-template="{ data }">
        <GcStatusRecord
          :primary="data[primaryText]"
          :secondary="data[secondaryText]"
          :status="data[status]"
        />
      </template>

      <template #default-item-template="{ data }">
        <div>
          <span>{{ displayItems(data) }}</span>
        </div>
      </template>
    </DxTagBox>

    <GcPopUpSelectRecord
      v-if="popupVisible"
      :popupVisible="popupVisible"
      :popupHiddenCallBack="popupHiddenCallBack"
      :popupConfig="popupConfig"
      :dataModel="undefined"
    />
  </div>
</template>
<script>
import DxTagBox from "devextreme-vue/tag-box";
import { GridReportService } from "../_services/api/reports/grid-report.service";
import GcStatusRecord from "./gc-record-field-template.vue";

export default {
  components: {
    DxTagBox,
    GcStatusRecord,
  },
  props: {
    valueChangeCallBack: {
      type: Function,
      default: () => function () {},
    },
    onValueChanged: {
      type: Function,
      default: () => function () {},
    },
    tagBoxOptions: {
      type: [Object, Array],
      default: () => {},
    },
    ignoreDataSourceFilter: {
      type: Boolean,
      default: false,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    onPressEnterKey: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      // dataSource: this.tagBoxOptions[0].dataSourceConfig.endpoint
      //   ? GridReportService.dataSourceConfig(
      //       this.tagBoxOptions[0].dataSourceConfig.endpoint,
      //       {
      //         select: [
      //           this.tagBoxOptions[0].valueExpr,
      //           this.tagBoxOptions[0].displayExpr,
      //           this.tagBoxOptions[0].editorTemplate
      //             ? this.tagBoxOptions[0].editorTemplate.status
      //               ? this.tagBoxOptions[0].editorTemplate.status.dataField
      //               : undefined
      //             : undefined,
      //         ],
      //         sort: this.tagBoxOptions[0].dataSourceConfig.sort
      //           ? this.tagBoxOptions[0].dataSourceConfig.sort
      //           : undefined,
      //         filter:
      //           this.tagBoxOptions[0].dataSourceConfig.filter &&
      //           !this.ignoreDataSourceFilter
      //             ? this.tagBoxOptions[0].dataSourceConfig.filter
      //             : undefined,
      //         key: this.tagBoxOptions[0].valueExpr
      //           ? this.tagBoxOptions[0].valueExpr
      //           : undefined,
      //       }
      //     )
      //   : undefined,
      items: this.tagBoxOptions[0].dataSourceConfig.data
        ? this.tagBoxOptions[0].dataSourceConfig.data
        : undefined,
      valueExpr: this.tagBoxOptions[0].valueExpr
        ? this.tagBoxOptions[0].valueExpr
        : undefined,
      displayExpr: this.tagBoxOptions[0].displayExpr
        ? this.tagBoxOptions[0].displayExpr
        : undefined,
      searchExpr: this.tagBoxOptions[0].searchExpr
        ? this.tagBoxOptions[0].searchExpr
        : this.tagBoxOptions[0].displayExpr
        ? [this.tagBoxOptions[0].valueExpr, this.tagBoxOptions[0].displayExpr]
        : undefined,
      primaryText: this.tagBoxOptions[0].editorTemplate
        ? this.tagBoxOptions[0].editorTemplate.primary[0].dataField
        : undefined,
      secondaryText: this.tagBoxOptions[0].editorTemplate
        ? this.tagBoxOptions[0].editorTemplate.secondary
          ? this.tagBoxOptions[0].editorTemplate.secondary[0].dataField
          : undefined
        : undefined,
      status: this.tagBoxOptions[0].editorTemplate
        ? this.tagBoxOptions[0].editorTemplate.status
          ? this.tagBoxOptions[0].editorTemplate.status.dataField
          : undefined
        : undefined,
      itemTemplate: this.tagBoxOptions[0].editorTemplate
        ? this.tagBoxOptions[0].editorTemplate.status
          ? "status-item-template"
          : "item-template"
        : "default-item-template",
      showClearButton: true,
      //   widgetItem: this.tagBoxOptions.editorType,
      dataField: this.tagBoxOptions[0].dataField,
      defaultValue: this.tagBoxOptions[0].defaultValue
        ? this.tagBoxOptions[0].defaultValue
        : undefined,
      popupVisible: false,
      popupConfig: undefined,
      selectedValues: [],
      tagBoxInstance: undefined,
      filterOperator: this.tagBoxOptions[0].filterOperator
        ? this.tagBoxOptions[0].filterOperator
        : "=",
    };
  },
  created() {
    if (
      this.dataModel[this.dataField] &&
      this.dataModel[this.dataField].length > 0
    )
      this.defaultValue = this.dataModel[this.dataField];
  },
  computed: {
    getDataSource() {
      return this.tagBoxOptions[0].dataSourceConfig.endpoint
        ? GridReportService.dataSourceConfig(
            this.tagBoxOptions[0].dataSourceConfig.endpoint,
            {
              select: this.getSelectFields,
              sort: this.tagBoxOptions[0].dataSourceConfig.sort
                ? this.tagBoxOptions[0].dataSourceConfig.sort
                : undefined,
              filter:
                this.tagBoxOptions[0].dataSourceConfig.filter &&
                !this.ignoreDataSourceFilter
                  ? this.tagBoxOptions[0].dataSourceConfig.filter
                  : undefined,
              key: this.tagBoxOptions[0].valueExpr
                ? this.tagBoxOptions[0].valueExpr
                : undefined,
              keyType: this.tagBoxOptions[0].dataSourceConfig.keyType
                ? this.tagBoxOptions[0].dataSourceConfig.keyType
                : undefined,
            }
          )
        : undefined;
    },
    getSelectFields() {
      var select = [
        this.tagBoxOptions[0].valueExpr,
        this.tagBoxOptions[0].displayExpr,
      ];

      if (this.tagBoxOptions[0].editorTemplate) {
        if (this.tagBoxOptions[0].editorTemplate.status)
          select.push(this.tagBoxOptions[0].editorTemplate.status.dataField);

        if (this.tagBoxOptions[0].editorTemplate.primary) {
          if (
            select.findIndex(
              (x) =>
                x == this.tagBoxOptions[0].editorTemplate.primary[0].dataField
            ) == -1
          ) {
            select.push(
              this.tagBoxOptions[0].editorTemplate.primary[0].dataField
            );
          }
        }

        if (this.tagBoxOptions[0].editorTemplate.secondary) {
          if (
            select.findIndex(
              (x) =>
                x == this.tagBoxOptions[0].editorTemplate.secondary[0].dataField
            ) == -1
          ) {
            select.push(
              this.tagBoxOptions[0].editorTemplate.secondary[0].dataField
            );
          }
        }
      }

      if (
        this.tagBoxOptions[0].dataSourceConfig.filter &&
        !this.ignoreDataSourceFilter
      ) {
        var filter = this.tagBoxOptions[0].dataSourceConfig.filter;
        filter.forEach((element) => {
          if (Array.isArray(element)) {
            if (
              element.length == 3 &&
              select.findIndex((x) => x == element[0]) == -1
            )
              select.push(element[0]);
          }
        });
      }

      return select;
    },
  },
  methods: {
    onOkClick(data) {
      this.popupHiddenCallBack(false);
      this.selectedValues = data;

      this.dataModel[this.dataField] = data;
    },
    popupHiddenCallBack(show) {
      this.popupVisible = show;
      this.popupConfig = undefined;
      this.tagBoxInstance.blur();
    },
    onOpened(e) {
      if (this.tagBoxOptions[0].touchEnabled) {
        setTimeout(() => {
          e.component.close();
        }, 1);
      }

      // e.component.instance().repaint();
    },
    onContentReady(e) {
      if (e.component.content()) {
        // var height =
        //   e.component.content().clientHeight -
        //   e.component.content().querySelector(".dx-list-select-all")
        //     .clientHeight;
        // e.component.content().style.height = `${height}px`;
        // e.component
        //   .content()
        //   .querySelector(".dx-list-select-all").style.display = "none";
      }
    },
    onFocusIn(e) {
      this.tagBoxInstance = e.component;

      if (this.tagBoxOptions[0].touchEnabled) {
        e.component.blur();
        this.popupConfig = {
          title: this.tagBoxOptions[0].label + " Filter",
          dataGrid: {
            toolbar: {
              salesrep: false,
            },
            options: {
              multipleSelect: true,
              // onRowClick: this.onCustomerRowClick,
              onOkClick: this.onOkClick,
              selectedValues: this.selectedValues,
              keyExpr: this.valueExpr,
            },
            dataSource: this.getDataSource,
            columns: this.tagBoxOptions[0].editorTemplate
              ? [
                  {
                    caption: "Code",
                    dataField: "Code",
                    cellTemplate: (data, info) => {
                      return (data.innerHTML = `<div class="custom-auto-complete">
                              <span class="auto-complete-primary">
                                ${
                                  info.data[
                                    this.tagBoxOptions[0].editorTemplate
                                      .primary[0].dataField
                                  ]
                                }
                              </span>
                              <span class="record-secondary gc-grid-code">
                                ${
                                  info.data[
                                    this.tagBoxOptions[0].editorTemplate
                                      .secondary[0].dataField
                                  ]
                                }
                              </span>
                            </div>`);
                    },
                  },
                  {
                    caption:
                      this.tagBoxOptions[0].editorTemplate.primary[0].dataField,
                    dataField:
                      this.tagBoxOptions[0].editorTemplate.primary[0].dataField,
                    visible: false,
                  },
                ]
              : [],
          },
        };

        this.popupVisible = true;
      }
    },
    displayItems(data) {
      if (data.value) return data.value;
      else return data;
    },
    onSelectionChanged(e) {
      this.selectedValues = e.value;
      let filter = [];
      var setFilter = [];

      e.value.forEach((element) => {
        setFilter = [];
        setFilter[0] = this.tagBoxOptions[0].dataField;
        setFilter[1] = this.filterOperator;
        setFilter[2] = element;
        if (filter.length > 0) filter.push("or");
        filter.push(setFilter);
      });

      this.valueChangeCallBack(this.dataField, filter);
    },
    initialized(e) {
      if (this.defaultValue) {
        e.component.beginUpdate();
        e.component.option("value", this.defaultValue);
        e.component.endUpdate();

        if (this.defaultValue)
          this.onSelectionChanged({ value: this.defaultValue });
      }
    },
  },
};
</script>

<style lang="scss">
.custom-auto-complete {
  .auto-complete-secondary {
    padding-left: 5px;
    font-size: 10px;
    color: gray;
  }
  .no-padding {
    padding-left: 0 !important;
  }
}

.dx-tagbox-popup-wrapper {
  .dx-list-item-before-bag.dx-list-select-checkbox-container {
    width: 28px !important;
  }
}

.gc-field-tag-dropDown {
  .dx-item.dx-list-item {
    display: inline-flex;
    .dx-list-select-checkbox-container {
      padding-top: 12px;
    }
  }

  .auto-complete-secondary {
    padding-left: unset !important;
  }
}
</style>
